import { render, staticRenderFns } from "./ListaDeArticulos.vue?vue&type=template&id=2f7f989c&scoped=true"
import script from "./ListaDeArticulos.vue?vue&type=script&lang=js"
export * from "./ListaDeArticulos.vue?vue&type=script&lang=js"
import style0 from "./ListaDeArticulos.vue?vue&type=style&index=0&id=2f7f989c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7f989c",
  null
  
)

export default component.exports